import { createStore } from "vuex";

// 引用模块文件
import login from "./modules/login.js";
import functionHandle from "./modules/function.js";
import personnelHandle from "./modules/personnel.js";
import accountHandle from "./modules/account.js";
import roleHandle from "./modules/role.js";
import categoryHandle from "./modules/category.js"
import clientHandle from "./modules/client.js"
import pictureHandle from "./modules/picture.js"
import quoteHandle from "./modules/quote.js"
import productionorderHandle from "./modules/productionorder.js"
import checkdeliveryHandle from "./modules/checkdelivery.js"
import deliveryorderHandle from "./modules/deliveryorder.js"
import checkbillHandle from "./modules/checkbill.js"
import billingmanageHandle from "./modules/billingmanage.js"
import billingmanageFactoryHandle from "./modules/billingmanageFactory.js"
import diamondsHandle from "./modules/diamonds.js"
import costHandle from "./modules/cost.js"
import costrecordHandle from "./modules/deliveryorder.js"

// 创建Vuex
export default createStore({
  modules: { // 模块化
    login,       // 载入 app 模块
    functionHandle,
    personnelHandle,
    accountHandle,
    roleHandle,
    categoryHandle,
    clientHandle,
    pictureHandle,
    quoteHandle,
    productionorderHandle,
    checkdeliveryHandle,
    deliveryorderHandle,
    checkbillHandle,
    billingmanageHandle,
    billingmanageFactoryHandle,
    diamondsHandle,
    costHandle,
    costrecordHandle,
  }
});
/*export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});*/
